var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"article"},[_c('article-metadata',{attrs:{"article":_vm.article}}),_vm._v(" "),_vm._t("cover"),_vm._v(" "),_c('article-main',{attrs:{"article":_vm.article}}),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }